module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDAgMAAAAXJUhJAAAADFBMVEXtKTntKTn4q7H////BGehuAAAAAXRSTlPUwVjOqwAAACdJREFUeAFjYcAFWEJxyoCIUZlRmVAy086ozKjMatwy5NkzKjOadgD63QQN7gpCVwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/at.png
// module id = yyq3
// module chunks = 0